module.exports = __webpack_public_path__ + "static/media/baker-finn.2b2fb31b.jpg";